export default __webpack_public_path__ + "static/media/checkbox-multiple-blank.df01c3e9.svg";